module.exports = __webpack_public_path__ + "images/pool-6874214f3ab54e5ce1f9f702e8fc1068.jpg";